import { render, staticRenderFns } from "./tagsBox.vue?vue&type=template&id=bdf8ded4&scoped=true"
import script from "./tagsBox.vue?vue&type=script&lang=ts"
export * from "./tagsBox.vue?vue&type=script&lang=ts"
import style0 from "./tagsBox.vue?vue&type=style&index=0&id=bdf8ded4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf8ded4",
  null
  
)

export default component.exports